import type Swiper from 'swiper'

export type SwiperModuleName =
  | 'Autoplay'
  | 'Thumbs'
  | 'Pagination'
  | 'FreeMode'

type SwiperModuleCtor = unknown

type SwiperModuleExports = Partial<Record<SwiperModuleName, SwiperModuleCtor>>

let cachedCorePromise: Promise<{ Swiper: typeof Swiper }> | null = null
let cachedModulesPromise: Promise<SwiperModuleExports> | null = null

async function loadCore() {
  if (!cachedCorePromise) {
    cachedCorePromise = import('swiper').then((m) => ({ Swiper: m.default }))
  }
  return cachedCorePromise
}

async function loadModules() {
  if (!cachedModulesPromise) {
    cachedModulesPromise = import('swiper/modules').then((m: any) => ({
      Autoplay: m.Autoplay,
      Thumbs: m.Thumbs,
      Pagination: m.Pagination,
      FreeMode: m.FreeMode,
    }))
  }
  return cachedModulesPromise
}

export async function getSwiper(modules: SwiperModuleName[] = []) {
  const [{ Swiper }, moduleExports] = await Promise.all([loadCore(), loadModules()])

  const resolvedModules = modules
    .map((name) => moduleExports[name])
    .filter(Boolean) as SwiperModuleCtor[]

  return { Swiper, modules: resolvedModules }
}

